export const InequalityLeftBlue = () => {
  return (
    <svg width='15' height='24' viewBox='0 0 26 52' fill='none'>
      <path
        d='M22 48L6.41745 27.8343C5.58259 26.7539 5.58259 25.2461 6.41745 24.1657L22 4'
        stroke='#6696FF'
        stroke-width='10'
      />
    </svg>
  );
};
